import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import PageTitle from "@/components/ui/page-title";

const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <title>Página não encontrada - MoovaTV</title>
        <meta name="description" content="A página que você está procurando não foi encontrada." />
      </Helmet>

      <div className="flex flex-col items-center justify-center min-h-screen">
        <h1 className="text-6xl font-bold mb-4">404</h1>
        <PageTitle className="mb-4">Página não encontrada no</PageTitle>
        <p className="text-lg text-muted-foreground mb-8">
          A página que você está procurando não existe.
        </p>
        <Button asChild>
          <Link to="/">Voltar ao início</Link>
        </Button>
      </div>
    </>
  );
};

export default NotFoundPage;
